import * as generated from '@/routes/org/users';
import { relative } from './relative';
export const index = relative(generated.index);
export const edit = relative(generated.edit);
export const update = relative(generated.update);
